/**
 * Knowledge Hub Realtime Service
 * Usa CRM Supabase (hfxydfbutbitijsakgjh) onde internal_messages vive.
 */

import { createClient } from '@supabase/supabase-js';

const CRM_SUPABASE_URL = process.env.REACT_APP_CRM_SUPABASE_URL;
const CRM_SUPABASE_KEY = process.env.REACT_APP_CRM_SUPABASE_KEY;

let supabase = null;

function getClient() {
  if (!supabase) {
    supabase = createClient(CRM_SUPABASE_URL, CRM_SUPABASE_KEY);
  }
  return supabase;
}

export function subscribeToInternalMessages(sellerId, onMessage) {
  const client = getClient();

  const channel = client
    .channel('internal-messages')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'internal_messages',
      },
      (payload) => {
        const msg = payload.new;
        if (msg.to_seller_id === sellerId || msg.to_seller_id === 'all' || msg.from_seller_id === sellerId) {
          onMessage(msg);
        }
      }
    )
    .subscribe();

  return channel;
}

export function subscribeToProjectComments(projectId, onComment) {
  const client = getClient();

  const channel = client
    .channel(`project-comments-${projectId}`)
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'kb_project_comments',
        filter: `project_id=eq.${projectId}`,
      },
      (payload) => {
        onComment(payload.new);
      }
    )
    .subscribe();

  return channel;
}

export function subscribeToProjectSteps(projectId, onStepChange) {
  const client = getClient();

  const channel = client
    .channel(`project-steps-${projectId}`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'kb_project_steps',
        filter: `project_id=eq.${projectId}`,
      },
      (payload) => {
        onStepChange(payload.eventType, payload.new || payload.old);
      }
    )
    .subscribe();

  return channel;
}

export default {
  subscribeToInternalMessages,
  subscribeToProjectComments,
  subscribeToProjectSteps,
};
